
import { Component, OnInit } from '@angular/core';
@Component({
  selector: 'casos-dashboard',
  templateUrl: './dash.component.html',
  styleUrls: ['./dash.component.css'],
})
export class CasosDashboard implements OnInit {
  constructor(){}
  ngOnInit(){}
}
